import { message } from 'antd'
import { apiCall } from '../../../api/apiCall'
import { AttachmentRecord } from '../../Shared/FileUploader/types'
import { Requests } from 'api'
import { MESSAGES } from './constants'

export const handleDownload = async (attachment: AttachmentRecord, orderId: number) => {
  try {
    const response = await apiCall.get(Requests.attachment({ id: attachment.id, orderId }).path)
    window.open(response.data.url, '_blank')
  } catch {
    message.error(MESSAGES.DOWNLOAD_ERROR)
  }
}
